import React, { useState, useEffect } from "react";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CustomSkeleton from "../CustomSkeleton/CustomSkeleton";

const CustomLegend = (props:any) => {
  const { data, colors, isApiFailed } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [legend, setLegend] = useState<any>([]);
  const [legendColors, setLegendColors] = useState<any>([]);
  const [isApi, setIsApi] = React.useState();

  useEffect(() => {
    setLegend(data);
    setLegendColors(colors);
  }, [props]);

  React.useEffect(() => {
    setIsApi(isApiFailed);
  }, [isApiFailed]);

  return (
    <div className="legendContainer">
      {legend && legend.length > 0 &&
        legend.map((l:any, i:number) => (
          <div className="legend" key={l.name}>
            <span
              className="bullet"
              style={{ backgroundColor: legendColors[i] }}
            />{" "}
            <span className="text">
              {isMobile &&
                (isApi ? (
                  <CustomSkeleton animation="wave" width={40} height={24} />
                ) : (
                  l.percentage + " % "
                ))}{" "}
              {l.name}{" "}
              {!isMobile &&
                (isApi ? (
                  <CustomSkeleton animation="wave" width={40} height={24} />
                ) : (
                  l.percentage + " % "
                ))}
            </span>
          </div>
        ))}
    </div>
  );
};

export default CustomLegend;
